import { createSelector } from 'reselect';

const _status = state => state.status;

export const getStatus = createSelector(
  _status, status => status
);
